import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 1000
};

const illustration = {
  animated: true
};

const greeting = {
  username: "Parth Rupareliya",
  title: "Hello, I'm Parth",
  subTitle: emoji(
    "Enthusiastic and self-motivated Software engineer keen to bring my knowledge and experience to solve real life problems and make world a better place."
  ),
  displayGreeting: true
};

const socialMediaLinks = {
  github: "",
  linkedin: "https://www.linkedin.com/in/parth-rupareliya-flutter",
  gmail: "androsoftp@gmail.com",
  gitlab: "",
  facebook: "",
  medium: "",
  stackoverflow: "",
  // Instagram, Twitter and Kaggle are also supported in the links!
  display: true
};

const skillsSection = {
  title: "What I do",
  subTitle: "FULL STACK DEVELOPER WHO WANTS TO BUILD EFFICIENT TECH",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Experience."
    ),
    emoji("⚡ Develop powerful and efficient backends."),
    emoji(
      "⚡ Integration of lots of third party services"
    )
  ],
  softwareSkills: [
    {
      skillName: "Dart",
      icon: "logos:dart"
    },
    {
      skillName: "Flutter",
      icon: "logos:flutter"
    },
    {
      skillName: "My Sql",
      icon: "logos:mysql-icon"
    },
    {
      skillName: "Postgresql",
      icon: "logos:postgresql"
    },
    {
      skillName: "Supabase",
      icon: "devicon:supabase"
    },
    {
      skillName: "Firebase",
      icon: "logos:firebase"
    },
    {
      skillName: "Git",
      icon: "vscode-icons:file-type-git"
    },
    {
      skillName: "Docker",
      icon: "logos:docker-icon"
    },
    {
      skillName: "GRPC",
      icon: "logos:grpc"
    },
    {
      skillName: "Kotlin",
      icon: "vscode-icons:file-type-kotlin"
    },
    {
      skillName: "C",
      icon: "vscode-icons:file-type-c"
    },
    {
      skillName: "C++",
      icon: "vscode-icons:file-type-cpp3"
    },
    {
      skillName: "Python",
      icon: "logos:python"
    },
    {
      skillName: "HTML 5",
      icon: "vscode-icons:file-type-html"
    },
    {
      skillName: "JavaScript",
      icon: "logos:javascript"
    },
    {
      skillName: "TypeScript",
      icon: "logos:typescript-icon"
    },
    {
      skillName: "Node Js",
      icon: "logos:nodejs-icon"
    },
    {
      skillName: "Java",
      icon: "logos:java"
    },
  ],
  display: true
};


const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "Shree Swami Atmanand Saraswati Institute of Technology",
      logo: require("./assets/images/ssasit.jpg"),
      subHeader: "Bachelor of Engineering in Computer Science",
      duration: "2021 - 2024",
      desc: "CGPA - 8.56",
    },
    {
      schoolName: "Tapi Diploma Engineering College",
      logo: require("./assets/images/tapi.jpg"),
      subHeader: "Diploma in Computer Engineering",
      duration: "2018 - 2021",
      desc: "CGPA - 9.94",
      // descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

const techStack = {
  viewSkillBars: false,
  experience: [
    {
      Stack: "Frontend/Design",
      progressPercentage: "90%"
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false
};

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Senior Software Engineer",
      company: "Empiric Infotech LLP",
      companylogo: require("./assets/images/empiric-logo.png"),
      date: "2024-Present",
      desc: "Lead 4 Junior developers, Developed Highly dynamic apps.",
      descBullets: [
        // "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      ]
    },
    {
      role: "Senior Software Engineer, Flutter",
      company: "Hit Infotech",
      companylogo: require("./assets/images/hit-logo.png"),
      date: "2023 - 2024",
      desc: "Developed many flutter apps. Improved collaborative skills working with team.",
      descBullets: [
        // "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      ]
    },
    {
      role: "Senior Flutter Developer at Androtech Solution",
      company: "Androtech Solution",
      companylogo: require("./assets/images/androtech-logo.png"),
      date: "2022 - 2023",
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      role: "Flutter Developer",
      company: "Freelancing",
      companylogo: require("./assets/images/freelancer-logo.png"),
      date: "2020 - 2022",
      // desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    }
  ]
};

const openSource = {
  showGithubProfile: "false",
  display: false
};


const achievementSection = {
  title: emoji(""),
  subtitle: "",
  achievementsCards: [
    // {
    //   title: "",
    //   subtitle: "",
    //   image: require("./assets/images/codeInLogo.webp"),
    //   imageAlt: "",
    //   footerLink: [
    //     {
    //       name: "Certification",
    //       url: ""
    //     }
    //   ]
    // },
  ],
  display: false
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle: "",
  displayMediumBlogs: "false",
  blogs: [
    // {
    //   url: "",
    //   title: "",
    //   description: ""
    // },
  ],
  display: false
};

const talkSection = {
  title: "TALKS",
  subtitle: emoji(""),
  talks: [
    // {
    //   title: "",
    //   subtitle: "",
    //   slides_url: "",
    //   event_url: ""
    // }
  ],
  display: false
};

const podcastSection = {
  title: emoji(""),
  subtitle: "",
  podcast: [
  ],
  display: false
};

const resumeSection = {
  file: require("./assets/resume.pdf"),
  display: true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle: "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+91-8511595025",
  email_address: "parthrupareliyar@gmail.com"
};


const twitterDetails = {
  userName: "twitter",
  display: false
};

const isHireable = true;

const bigProjects = {
  title: "Projects",
  // subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    // {
    //   image: require("./assets/projects/manna.webp"),
    //   projectName: "Manna Bitcoin Wallet",
    //   projectDesc: "Liquid wallet app that your grandma can use. Very simple and feature rich.",
    //   footerLink: [
    //   ],
    // },
    {
      image: require("./assets/projects/vedu.png"),
      projectName: "Deutsch & Der Die Das Artikel",
      projectDesc: "An App that helps people learn german with help of AI images.",
      footerLink: [
        {
          name: "View",
          url: "https://vedu.ai"
        }
      ],
    },
    {
      image: require("./assets/projects/reactionz.webp"),
      projectName: "Reactionz",
      projectDesc: "Multi-platform communication system for businesses.",
      footerLink: [
        {
          name: "View",
          url: "https://reactionz.io"
        },
        {
          name: "View",
          platform: 'android',
          url: "https://m.reactionz.io"
        },
      ],
    },
    {
      image: require("./assets/projects/pet corner.webp"),
      projectName: "Pet Corner Middle East",
      projectDesc: "UAE pet store selling Pet products and Pet grooming services via Mobile App.",
      footerLink: [
        {
          name: "View",
          platform: 'android',
          url: "https://play.google.com/store/apps/details?id=com.petcornerdubai"
        },
        {
          name: "View",
          platform: 'ios',
          url: "https://apps.apple.com/us/app/pet-corner-middle-east/id6447665375"
        },
      ],
    },
    {
      image: require("./assets/projects/shradhanjali.webp"),
      projectName: "Shradhanjali RIP Card Maker",
      projectDesc: "Create Tribute, Condolence, Memorial, Condolence Meeting, Panidhol Cards with ease.",
      footerLink: [
        {
          name: "View",
          platform: 'android',
          url: "https://play.google.com/store/apps/details?id=com.shradhanjali.card.maker"
        },
        {
          name: "View",
          platform: 'ios',
          url: "https://apps.apple.com/us/app/shradhanjali-card-maker/id6456324479"
        },
      ],
    },
    {
      image: require("./assets/projects/reelify.webp"),
      projectName: "Reelify - Story & Reels maker",
      projectDesc: "App to create reels from photos and videos for pre built templates using ffmpeg.",
      footerLink: [
        {
          name: "View",
          platform: 'android',
          url: "https://play.google.com/store/apps/details?id=com.hitinfotech.reels"
        },
      ],
    },
    {
      image: require("./assets/projects/ocm.webp"),
      projectName: "Open Cart Admin",
      projectDesc: "Admin features of open cart e-commerce store on mobile.",
      footerLink: [
        {
          name: "View",
          platform: 'android',
          url: "https://play.google.com/store/apps/details?id=com.hitinfotech.ocm_app"
        },
        {
          name: "View",
          platform: 'ios',
          url: "https://apps.apple.com/us/app/opencart-admin-mobile-app/id6482107603"
        },
        {
          name: "Checkout",
        },
      ],
      appUrl: "/apps/ocm/",
      notes: [
        "Store URL : http://hitinfotech.com/demo/sews",
        "Test Username : demo",
        "Test Password : demo",
        "You may have to enable third party cookie for demo to work!"
      ],
    },
    {
      image: require("./assets/projects/egspay.webp"),
      projectName: "EGSPay",
      projectDesc: "EGSPay brings great deals and offers for all your gaming needs. Buy your digital game codes to reload your favourite games! Instant Delivery 24x7!",
      footerLink: [
        {
          name: "View",
          platform: 'android',
          url: "https://play.google.com/store/apps/details?id=com.egspay.android"
        },
      ]
    },
    {
      image: require("./assets/projects/image_vault.png"),
      projectName: "Image Vault",
      projectDesc: "Android app to secure images, videos or other files and notes with password, Create albums, decoy others with dummy images.",
      footerLink: [{ name: "Checkout" }],
      appUrl: "/apps/image_vault/",
    },
    {
      image: require("./assets/projects/todo.png"),
      projectName: "TODO Task Scheduler",
      projectDesc: "Schedule tasks, get reminders, create to-do lists, categorize tasks, attach notes and attachments.",
      footerLink: [{ name: "Checkout" }],
      appUrl: "/apps/todo/",
    },
    {
      image: require("./assets/projects/screen_translator.png"),
      projectName: "All In One Translator",
      projectDesc: "Android app to translate text using google ml kit. Translate text from images as well as text on the screen.",
      footerLink: [{ name: "Checkout" }],
      appUrl: "/apps/screen-translator/",
    },
    {
      image: require("./assets/projects/astromeda.png"),
      projectName: "Astromeda IOT Medicine Reminder",
      projectDesc: "IOT app that communicate with medicine pill box to remind patients. Contains settings for IOT device, bluetooth communication and reminders with notifications.",
      footerLink: [{ name: "Checkout" }],
      appUrl: "/apps/astromeda/",
      notes: [
        "Test Email : test@gmail.com",
        "Test Password : 123456"
      ],
    },
    {
      image: require("./assets/projects/school.png"),
      projectName: "Mount Carmel School APP UI",
      projectDesc: "Freelancing Project to design school app UI.",
      footerLink: [{ name: "Checkout" }],
      appUrl: "/apps/school/",
    },
    {
      image: require("./assets/projects/quoteus.png"),
      projectName: "QuoteUs Retro Music App UI",
      projectDesc: "Freelancing Project to implement design according to client's requirement achieving exact replica of given UI.",
      footerLink: [{ name: "Checkout" }],
      appUrl: "/apps/quoteus/",
    },
    {
      image: require("./assets/projects/quotes.png"),
      projectName: "MM Quotes",
      projectDesc: "App made to list, cache, bookmark and search Quotes category or author wise.",
      footerLink: [{ name: "Checkout" }],
      appUrl: "/apps/quotes/",
      notes: ['Use `cat:` and `auth:` flag to search Category and Author wise.'],
    },
  ],
  display: true
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
